"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountExists = accountExists;
exports.default = LoginSignup;
exports.validEmail = validEmail;

var _react = _interopRequireWildcard(require("react"));

var _reactBootstrap = require("react-bootstrap");

require("./login.scss");

var _firebase = require("../firebase");

var _auth = require("firebase/auth");

var _components = require("../components");

var _Login = _interopRequireDefault(require("./Login"));

var _CreateAccount = _interopRequireDefault(require("./CreateAccount"));

var _ForgotPass = _interopRequireDefault(require("./ForgotPass"));

var _primitives = require("@bedrock-layout/primitives");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function validEmail(email) {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
}

function accountExists(_x) {
  return _accountExists.apply(this, arguments);
}

function _accountExists() {
  _accountExists = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(email) {
    var methods;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!validEmail(email)) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return (0, _auth.fetchSignInMethodsForEmail)(_firebase.auth, email);

          case 3:
            methods = _context.sent;

            if (!(methods.length > 0)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", true);

          case 6:
            return _context.abrupt("return", false);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _accountExists.apply(this, arguments);
}

var loginStates = {
  'signin': 'signin',
  'create': 'create',
  'forgot': 'forgot'
};

function LoginSignup(props) {
  var _useState = (0, _react.useState)('create'),
      _useState2 = _slicedToArray(_useState, 2),
      action = _useState2[0],
      setAction = _useState2[1];

  var body = '';

  switch (action) {
    case loginStates.signin:
      body = /*#__PURE__*/_react.default.createElement(_Login.default, {
        setAction: setAction
      });
      break;

    case loginStates.create:
      body = /*#__PURE__*/_react.default.createElement(_CreateAccount.default, {
        setAction: setAction
      });
      break;

    case loginStates.forgot:
      body = /*#__PURE__*/_react.default.createElement(_ForgotPass.default, {
        setAction: setAction
      });
      break;
  }

  return /*#__PURE__*/_react.default.createElement(_primitives.Cover, {
    top: /*#__PURE__*/_react.default.createElement("div", {
      className: "form-header"
    }, /*#__PURE__*/_react.default.createElement("h5", {
      className: 'form-header-item' + (action === loginStates.create ? ' selected' : ''),
      onClick: function onClick() {
        return setAction(loginStates.create);
      }
    }, "Create Account"), /*#__PURE__*/_react.default.createElement("h5", {
      className: 'form-header-item' + (action === loginStates.signin || action === loginStates.forgot ? ' selected' : ''),
      onClick: function onClick() {
        return setAction(loginStates.signin);
      }
    }, "Sign In"))
  }, body);
}